const indianMediterraneanRecipes = [
  // ============================================================
  // INDIAN RECIPES (1-12)
  // ============================================================

  // 1. Chana Masala
  {
    title: 'Chana Masala',
    description:
      'A hearty North Indian chickpea curry simmered in a richly spiced tomato-onion gravy. This vegan comfort food is packed with protein and pairs perfectly with rice or warm naan.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/chana-masala.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/chana-masala-prep.jpg', caption: 'Toasting whole spices in oil', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 35,
    totalTime: 50,
    difficulty: 'easy',
    spiceLevel: 3,

    cuisine: 'Indian',
    region: 'South Asia',
    country: 'India',

    categories: ['Dinner'],
    tags: [
      'vegan',
      'vegetarian',
      'gluten-free',
      'dairy-free',
      'high-protein',
      'high-iron',
      'high-fiber',
      'one-pot',
      'budget-friendly',
      'meal-prep',
      'freezer-friendly',
      'comfort-food',
      'weeknight-dinner',
      'family-friendly',
    ],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 320,
      protein: 14,
      carbs: 48,
      fat: 9,
      fiber: 12,
      sugar: 8,
      sodium: 580,
      iron: 5.2,
    },

    ingredients: [
      { qty: 2, unit: 'cans (15 oz)', item: 'chickpeas, drained and rinsed', group: 'Main' },
      { qty: 1, unit: 'large', item: 'yellow onion, finely diced', group: 'Main' },
      { qty: 4, unit: 'cloves', item: 'garlic, minced', group: 'Main' },
      { qty: 1, unit: 'inch', item: 'fresh ginger, grated', group: 'Main' },
      { qty: 2, unit: '', item: 'serrano peppers, minced', group: 'Main' },
      { qty: 1, unit: 'can (14 oz)', item: 'crushed tomatoes', group: 'Main' },
      { qty: 3, unit: 'tbsp', item: 'vegetable oil', group: 'Main' },
      { qty: 1, unit: 'tsp', item: 'cumin seeds', group: 'Spices' },
      { qty: 1, unit: 'tsp', item: 'ground coriander', group: 'Spices' },
      { qty: 1, unit: 'tsp', item: 'ground turmeric', group: 'Spices' },
      { qty: 1, unit: 'tsp', item: 'garam masala', group: 'Spices' },
      { qty: 0.5, unit: 'tsp', item: 'red chili powder', group: 'Spices' },
      { qty: 0.5, unit: 'tsp', item: 'amchur (dried mango powder)', group: 'Spices' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Spices' },
      { qty: 0.5, unit: 'cup', item: 'water', group: 'Main' },
      { qty: 2, unit: 'tbsp', item: 'fresh cilantro, chopped', group: 'Garnish' },
      { qty: 1, unit: '', item: 'lemon, cut into wedges', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Heat oil in a large heavy-bottomed pot over medium heat. Add cumin seeds and let them sizzle until fragrant, about 30 seconds.', timerMinutes: null },
      { order: 2, instruction: 'Add diced onion and cook, stirring occasionally, until golden brown, about 8 minutes.', timerMinutes: 8 },
      { order: 3, instruction: 'Add garlic, ginger, and serrano peppers. Saute for 1 minute until fragrant.', timerMinutes: 1 },
      { order: 4, instruction: 'Stir in ground coriander, turmeric, red chili powder, and salt. Cook for 30 seconds to bloom the spices.', timerMinutes: null },
      { order: 5, instruction: 'Pour in crushed tomatoes and cook, stirring frequently, until the mixture thickens and oil begins to separate, about 5 minutes.', timerMinutes: 5 },
      { order: 6, instruction: 'Add drained chickpeas and water. Stir to coat, then bring to a simmer. Cover and cook for 20 minutes, stirring occasionally.', timerMinutes: 20 },
      { order: 7, instruction: 'Sprinkle in garam masala and amchur powder. Stir well and cook for another 2 minutes. Adjust salt to taste.', timerMinutes: 2 },
      { order: 8, instruction: 'Garnish with fresh cilantro and serve with lemon wedges, rice, or warm naan.', timerMinutes: null },
    ],
    notes: 'For a smokier flavor, add a small piece of charcoal lit and placed in a small bowl set inside the pot (dhungar method). Leftovers taste even better the next day as the spices deepen.',

    communityRating: 4.7,
    communityRatingCount: 380,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-15').toISOString(),
  },

  // 2. Tandoori Chicken
  {
    title: 'Tandoori Chicken',
    description:
      'Juicy chicken legs marinated in a vibrant blend of yogurt, ginger-garlic paste, and warming spices, then grilled until charred and smoky. A North Indian classic that delivers bold flavor with minimal effort.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/tandoori-chicken.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/tandoori-chicken-prep.jpg', caption: 'Chicken marinating in yogurt spice mixture', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 20,
    cookTime: 30,
    totalTime: 50,
    difficulty: 'medium',
    spiceLevel: 3,

    cuisine: 'Indian',
    region: 'South Asia',
    country: 'India',

    categories: ['Dinner'],
    tags: [
      'high-protein',
      'low-carb',
      'gluten-free',
      'high-iron',
      'grilling',
      'meal-prep',
      'make-ahead',
      'date-night',
      'family-friendly',
      'weeknight-dinner',
    ],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 380,
      protein: 42,
      carbs: 6,
      fat: 20,
      fiber: 1,
      sugar: 3,
      sodium: 650,
      iron: 3.5,
    },

    ingredients: [
      { qty: 3, unit: 'lb', item: 'chicken legs and thighs, skin removed, scored', group: 'Main' },
      { qty: 1, unit: 'cup', item: 'plain whole-milk yogurt', group: 'Marinade' },
      { qty: 2, unit: 'tbsp', item: 'lemon juice', group: 'Marinade' },
      { qty: 1, unit: 'tbsp', item: 'ginger-garlic paste', group: 'Marinade' },
      { qty: 2, unit: 'tsp', item: 'Kashmiri red chili powder', group: 'Marinade' },
      { qty: 1, unit: 'tsp', item: 'ground cumin', group: 'Marinade' },
      { qty: 1, unit: 'tsp', item: 'ground coriander', group: 'Marinade' },
      { qty: 0.5, unit: 'tsp', item: 'ground turmeric', group: 'Marinade' },
      { qty: 0.5, unit: 'tsp', item: 'garam masala', group: 'Marinade' },
      { qty: 0.25, unit: 'tsp', item: 'ground cardamom', group: 'Marinade' },
      { qty: 1.5, unit: 'tsp', item: 'salt', group: 'Marinade' },
      { qty: 2, unit: 'tbsp', item: 'vegetable oil', group: 'Marinade' },
      { qty: 1, unit: 'drop', item: 'red food coloring (optional)', group: 'Marinade' },
      { qty: 2, unit: 'tbsp', item: 'melted butter, for basting', group: 'Finishing' },
      { qty: 1, unit: '', item: 'red onion, sliced into rings', group: 'Garnish' },
      { qty: 1, unit: '', item: 'lemon, cut into wedges', group: 'Garnish' },
      { qty: 2, unit: 'tbsp', item: 'fresh cilantro, chopped', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Score the chicken pieces with deep slashes to allow the marinade to penetrate. Place in a large bowl.', timerMinutes: null },
      { order: 2, instruction: 'In a separate bowl, whisk together yogurt, lemon juice, ginger-garlic paste, all ground spices, salt, oil, and food coloring if using. Mix until smooth.', timerMinutes: null },
      { order: 3, instruction: 'Pour the marinade over the chicken and massage it into every cut and crevice. Cover and refrigerate for at least 4 hours, or ideally overnight.', timerMinutes: 240 },
      { order: 4, instruction: 'Preheat your grill to high heat (500F) or set your oven broiler to high. If using the oven, place a wire rack over a foil-lined baking sheet.', timerMinutes: null },
      { order: 5, instruction: 'Remove chicken from the fridge 30 minutes before cooking to take the chill off. Shake off excess marinade.', timerMinutes: null },
      { order: 6, instruction: 'Grill or broil the chicken for 12-15 minutes per side, basting with melted butter halfway through, until the internal temperature reaches 165F and edges are nicely charred.', timerMinutes: 15 },
      { order: 7, instruction: 'Flip and cook the second side for another 12-15 minutes, basting again with butter.', timerMinutes: 15 },
      { order: 8, instruction: 'Let the chicken rest for 5 minutes, then serve on a platter with sliced red onion, lemon wedges, and fresh cilantro.', timerMinutes: 5 },
    ],
    notes: 'Kashmiri chili powder gives the signature red color without excessive heat. For the most authentic flavor, marinate overnight. A cast iron grill pan works well indoors if you do not have an outdoor grill.',

    communityRating: 4.8,
    communityRatingCount: 420,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-15').toISOString(),
  },

  // 3. Aloo Gobi
  {
    title: 'Aloo Gobi',
    description:
      'A vibrant dry curry of tender potatoes and cauliflower florets, coated in fragrant turmeric and cumin. This Punjabi staple is naturally vegan and makes a satisfying weeknight dinner.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/aloo-gobi.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/aloo-gobi-prep.jpg', caption: 'Cauliflower and potatoes cut into even pieces', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 30,
    totalTime: 45,
    difficulty: 'easy',
    spiceLevel: 2,

    cuisine: 'Indian',
    region: 'South Asia',
    country: 'India',

    categories: ['Dinner'],
    tags: [
      'vegan',
      'vegetarian',
      'gluten-free',
      'dairy-free',
      'high-fiber',
      'high-iron',
      'low-calorie',
      'one-pan',
      'budget-friendly',
      'weeknight-dinner',
      'family-friendly',
      'comfort-food',
    ],

    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 220,
      protein: 6,
      carbs: 34,
      fat: 8,
      fiber: 6,
      sugar: 5,
      sodium: 480,
      iron: 3.0,
    },

    ingredients: [
      { qty: 1, unit: 'medium', item: 'head cauliflower, cut into small florets', group: 'Main' },
      { qty: 3, unit: 'medium', item: 'Yukon Gold potatoes, peeled and cubed', group: 'Main' },
      { qty: 1, unit: 'large', item: 'yellow onion, diced', group: 'Main' },
      { qty: 2, unit: 'medium', item: 'tomatoes, diced', group: 'Main' },
      { qty: 3, unit: 'cloves', item: 'garlic, minced', group: 'Main' },
      { qty: 1, unit: 'inch', item: 'fresh ginger, grated', group: 'Main' },
      { qty: 1, unit: '', item: 'green chili, slit', group: 'Main' },
      { qty: 3, unit: 'tbsp', item: 'vegetable oil', group: 'Main' },
      { qty: 1, unit: 'tsp', item: 'cumin seeds', group: 'Spices' },
      { qty: 1, unit: 'tsp', item: 'ground turmeric', group: 'Spices' },
      { qty: 1, unit: 'tsp', item: 'ground coriander', group: 'Spices' },
      { qty: 0.5, unit: 'tsp', item: 'red chili powder', group: 'Spices' },
      { qty: 0.5, unit: 'tsp', item: 'garam masala', group: 'Spices' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Spices' },
      { qty: 2, unit: 'tbsp', item: 'fresh cilantro, chopped', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Heat oil in a large skillet or wok over medium-high heat. Add cumin seeds and let them splutter for 15 seconds.', timerMinutes: null },
      { order: 2, instruction: 'Add diced onion and saute until softened and lightly golden, about 5 minutes.', timerMinutes: 5 },
      { order: 3, instruction: 'Stir in garlic, ginger, and green chili. Cook for 1 minute until fragrant.', timerMinutes: 1 },
      { order: 4, instruction: 'Add turmeric, ground coriander, red chili powder, and salt. Stir for 30 seconds to bloom the spices.', timerMinutes: null },
      { order: 5, instruction: 'Add diced tomatoes and cook until they break down into a paste, about 3 minutes.', timerMinutes: 3 },
      { order: 6, instruction: 'Add cubed potatoes and cauliflower florets. Toss well to coat in the spice mixture. Reduce heat to medium-low, cover, and cook for 20 minutes, stirring every 5 minutes, until potatoes are fork-tender.', timerMinutes: 20 },
      { order: 7, instruction: 'Sprinkle garam masala over the top and stir gently. Cook uncovered for 2 more minutes to let any excess moisture evaporate.', timerMinutes: 2 },
      { order: 8, instruction: 'Garnish with fresh cilantro and serve with warm roti or steamed rice.', timerMinutes: null },
    ],
    notes: 'Do not stir too aggressively once the potatoes are tender or they will fall apart. If the vegetables start sticking to the pan, sprinkle a tablespoon of water at a time rather than adding oil.',

    communityRating: 4.4,
    communityRatingCount: 260,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-15').toISOString(),
  },

  // 4. Samosas
  {
    title: 'Samosas',
    description:
      'Crispy golden pastry triangles stuffed with a warmly spiced potato and pea filling. These iconic Indian snacks are perfect for parties and taste incredible with tamarind or mint chutney.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/samosas.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/samosas-prep.jpg', caption: 'Filling and folding the samosa dough', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 45,
    cookTime: 25,
    totalTime: 70,
    difficulty: 'hard',
    spiceLevel: 2,

    cuisine: 'Indian',
    region: 'South Asia',
    country: 'India',

    categories: ['Snacks', 'Appetizers'],
    tags: [
      'vegan',
      'vegetarian',
      'dairy-free',
      'high-fiber',
      'high-iron',
      'budget-friendly',
      'party',
      'freezer-friendly',
      'batch-cooking',
      'family-friendly',
      'game-day',
    ],

    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 280,
      protein: 6,
      carbs: 38,
      fat: 12,
      fiber: 4,
      sugar: 2,
      sodium: 420,
      iron: 2.8,
    },

    ingredients: [
      { qty: 2, unit: 'cups', item: 'all-purpose flour', group: 'Dough' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Dough' },
      { qty: 0.25, unit: 'tsp', item: 'ajwain (carom seeds)', group: 'Dough' },
      { qty: 4, unit: 'tbsp', item: 'vegetable oil', group: 'Dough' },
      { qty: 0.5, unit: 'cup', item: 'cold water, as needed', group: 'Dough' },
      { qty: 4, unit: 'medium', item: 'potatoes, boiled, peeled, and roughly mashed', group: 'Filling' },
      { qty: 0.75, unit: 'cup', item: 'frozen green peas, thawed', group: 'Filling' },
      { qty: 2, unit: 'tbsp', item: 'vegetable oil', group: 'Filling' },
      { qty: 1, unit: 'tsp', item: 'cumin seeds', group: 'Filling' },
      { qty: 1, unit: 'tsp', item: 'fennel seeds', group: 'Filling' },
      { qty: 1, unit: 'inch', item: 'fresh ginger, grated', group: 'Filling' },
      { qty: 1, unit: '', item: 'green chili, minced', group: 'Filling' },
      { qty: 1, unit: 'tsp', item: 'ground coriander', group: 'Filling' },
      { qty: 0.5, unit: 'tsp', item: 'garam masala', group: 'Filling' },
      { qty: 0.5, unit: 'tsp', item: 'amchur (dried mango powder)', group: 'Filling' },
      { qty: 0.5, unit: 'tsp', item: 'red chili powder', group: 'Filling' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Filling' },
      { qty: 2, unit: 'tbsp', item: 'fresh cilantro, chopped', group: 'Filling' },
      { qty: 4, unit: 'cups', item: 'vegetable oil, for deep frying', group: 'Frying' },
    ],
    steps: [
      { order: 1, instruction: 'Make the dough: combine flour, salt, and ajwain in a bowl. Rub in the oil until the mixture resembles coarse breadcrumbs. Gradually add cold water and knead into a firm, smooth dough. Cover with a damp cloth and rest for 30 minutes.', timerMinutes: 30 },
      { order: 2, instruction: 'Make the filling: heat 2 tbsp oil in a pan over medium heat. Add cumin seeds and fennel seeds, let them splutter.', timerMinutes: null },
      { order: 3, instruction: 'Add ginger and green chili, saute for 30 seconds. Add ground coriander, red chili powder, and salt. Stir for 15 seconds.', timerMinutes: null },
      { order: 4, instruction: 'Add mashed potatoes and peas. Mix well, then stir in garam masala, amchur, and cilantro. Let the filling cool completely.', timerMinutes: null },
      { order: 5, instruction: 'Divide the dough into 8 equal balls. Roll each ball into an oval, then cut in half. Form each half into a cone shape by folding and sealing the straight edge with a dab of water.', timerMinutes: null },
      { order: 6, instruction: 'Fill each cone with about 2 tablespoons of the potato filling. Seal the top edge firmly with water, pressing with a fork to crimp.', timerMinutes: null },
      { order: 7, instruction: 'Heat oil in a deep pot or wok to 325F. Fry samosas in batches of 3-4, turning occasionally, until deep golden brown and crispy, about 8-10 minutes per batch. Do not overheat the oil or the outside will brown before the pastry cooks through.', timerMinutes: 10 },
      { order: 8, instruction: 'Drain on paper towels and serve hot with tamarind chutney and green mint chutney.', timerMinutes: null },
    ],
    notes: 'The key to flaky samosas is a firm dough and low-temperature frying. You can freeze uncooked samosas on a tray, then transfer to a bag; fry straight from frozen, adding 2-3 extra minutes of cook time.',

    communityRating: 4.6,
    communityRatingCount: 310,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-15').toISOString(),
  },

  // 5. Lamb Biryani
  {
    title: 'Lamb Biryani',
    description:
      'Fragrant layers of saffron-infused basmati rice and tender slow-cooked lamb, sealed and steamed to perfection. This celebratory Hyderabadi dish is the crown jewel of Indian cuisine.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/lamb-biryani.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/lamb-biryani-prep.jpg', caption: 'Layering rice over marinated lamb', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 40,
    cookTime: 60,
    totalTime: 100,
    difficulty: 'hard',
    spiceLevel: 3,

    cuisine: 'Indian',
    region: 'South Asia',
    country: 'India',

    categories: ['Dinner'],
    tags: [
      'high-protein',
      'high-iron',
      'one-pot',
      'date-night',
      'celebration',
      'sunday-dinner',
      'comfort-food',
      'make-ahead',
    ],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 580,
      protein: 32,
      carbs: 62,
      fat: 22,
      fiber: 3,
      sugar: 4,
      sodium: 720,
      iron: 4.8,
    },

    ingredients: [
      { qty: 2, unit: 'lb', item: 'bone-in lamb shoulder, cut into large chunks', group: 'Lamb' },
      { qty: 1, unit: 'cup', item: 'plain yogurt', group: 'Lamb' },
      { qty: 1.5, unit: 'tbsp', item: 'ginger-garlic paste', group: 'Lamb' },
      { qty: 2, unit: 'tsp', item: 'red chili powder', group: 'Lamb' },
      { qty: 1, unit: 'tsp', item: 'ground turmeric', group: 'Lamb' },
      { qty: 1.5, unit: 'tsp', item: 'salt', group: 'Lamb' },
      { qty: 2, unit: 'tbsp', item: 'lemon juice', group: 'Lamb' },
      { qty: 3, unit: 'cups', item: 'basmati rice, soaked 30 minutes', group: 'Rice' },
      { qty: 8, unit: 'cups', item: 'water, for parboiling rice', group: 'Rice' },
      { qty: 4, unit: '', item: 'green cardamom pods', group: 'Rice' },
      { qty: 4, unit: '', item: 'whole cloves', group: 'Rice' },
      { qty: 1, unit: '', item: 'cinnamon stick (3-inch)', group: 'Rice' },
      { qty: 2, unit: '', item: 'bay leaves', group: 'Rice' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Rice' },
      { qty: 2, unit: 'large', item: 'yellow onions, thinly sliced', group: 'Assembly' },
      { qty: 0.25, unit: 'cup', item: 'vegetable oil', group: 'Assembly' },
      { qty: 0.25, unit: 'tsp', item: 'saffron threads, soaked in 3 tbsp warm milk', group: 'Assembly' },
      { qty: 2, unit: 'tbsp', item: 'ghee', group: 'Assembly' },
      { qty: 0.25, unit: 'cup', item: 'fresh mint leaves', group: 'Assembly' },
      { qty: 0.25, unit: 'cup', item: 'fresh cilantro, chopped', group: 'Assembly' },
      { qty: 1, unit: 'cup', item: 'all-purpose flour mixed with water, for sealing (optional)', group: 'Assembly' },
    ],
    steps: [
      { order: 1, instruction: 'Marinate the lamb with yogurt, ginger-garlic paste, chili powder, turmeric, salt, and lemon juice. Refrigerate for at least 2 hours, preferably overnight.', timerMinutes: 120 },
      { order: 2, instruction: 'Fry the sliced onions in oil over medium-high heat until deep golden brown and crispy, about 12-15 minutes. Remove and drain on paper towels. Reserve the oil.', timerMinutes: 15 },
      { order: 3, instruction: 'In the same pot with reserved onion oil, add marinated lamb. Cook on medium-high heat, stirring for 5 minutes. Add half the fried onions, cover, and cook on low heat for 30 minutes until lamb is almost tender.', timerMinutes: 30 },
      { order: 4, instruction: 'Meanwhile, bring 8 cups of water to a boil with cardamom, cloves, cinnamon, bay leaves, and salt. Add soaked and drained rice. Parboil for exactly 5 minutes until rice is 70% cooked. Drain immediately.', timerMinutes: 5 },
      { order: 5, instruction: 'Layer the parboiled rice evenly over the cooked lamb. Scatter remaining fried onions, mint, and cilantro on top. Drizzle saffron milk and dot with ghee.', timerMinutes: null },
      { order: 6, instruction: 'Seal the pot tightly with aluminum foil, then place the lid on top. Cook on the lowest heat possible for 25 minutes to let the steam finish cooking the rice.', timerMinutes: 25 },
      { order: 7, instruction: 'Remove from heat and let rest, still sealed, for 5 minutes. Then gently open and use a large spoon to serve from the bottom up, mixing the layers.', timerMinutes: 5 },
    ],
    notes: 'The key to great biryani is not overcooking the rice during parboiling. Each grain should be separate after steaming. For extra richness, add a splash of kewra water or rose water before sealing.',

    communityRating: 4.9,
    communityRatingCount: 440,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-15').toISOString(),
  },

  // 6. Naan Bread
  {
    title: 'Naan Bread',
    description:
      'Soft, pillowy, and lightly charred Indian flatbread brushed with garlic butter. Made with yogurt-enriched dough, this stovetop naan rivals what you would get from a tandoor oven.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/naan-bread.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/naan-bread-prep.jpg', caption: 'Rolling out naan dough', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 8,
    prepTime: 20,
    cookTime: 20,
    totalTime: 40,
    difficulty: 'medium',
    spiceLevel: 0,

    cuisine: 'Indian',
    region: 'South Asia',
    country: 'India',

    categories: ['Sides'],
    tags: [
      'vegetarian',
      'baking',
      'family-friendly',
      'comfort-food',
      'weeknight-dinner',
      'party',
      'budget-friendly',
    ],

    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 210,
      protein: 6,
      carbs: 34,
      fat: 6,
      fiber: 1,
      sugar: 3,
      sodium: 380,
      iron: 2.0,
    },

    ingredients: [
      { qty: 3, unit: 'cups', item: 'all-purpose flour', group: 'Dough' },
      { qty: 1, unit: 'tsp', item: 'sugar', group: 'Dough' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Dough' },
      { qty: 1, unit: 'tsp', item: 'baking powder', group: 'Dough' },
      { qty: 0.5, unit: 'tsp', item: 'baking soda', group: 'Dough' },
      { qty: 0.75, unit: 'cup', item: 'warm milk', group: 'Dough' },
      { qty: 0.25, unit: 'cup', item: 'plain yogurt', group: 'Dough' },
      { qty: 2, unit: 'tbsp', item: 'vegetable oil', group: 'Dough' },
      { qty: 3, unit: 'tbsp', item: 'butter, melted', group: 'Garlic Butter' },
      { qty: 2, unit: 'cloves', item: 'garlic, minced', group: 'Garlic Butter' },
      { qty: 1, unit: 'tbsp', item: 'fresh parsley or cilantro, chopped', group: 'Garlic Butter' },
    ],
    steps: [
      { order: 1, instruction: 'In a large bowl, whisk together flour, sugar, salt, baking powder, and baking soda.', timerMinutes: null },
      { order: 2, instruction: 'Add warm milk, yogurt, and oil. Mix until a shaggy dough forms, then knead on a floured surface for 5 minutes until smooth and slightly tacky. Place in an oiled bowl, cover, and let rest for 1 hour.', timerMinutes: 60 },
      { order: 3, instruction: 'Mix melted butter with minced garlic and chopped herbs. Set aside.', timerMinutes: null },
      { order: 4, instruction: 'Divide the dough into 8 equal balls. Roll each ball into a teardrop or oval shape, about 1/4 inch thick.', timerMinutes: null },
      { order: 5, instruction: 'Heat a cast iron skillet over high heat until very hot, about 3 minutes. Lightly wet one side of the naan with water and place it wet-side down on the dry skillet.', timerMinutes: null },
      { order: 6, instruction: 'Cook until large bubbles form on the surface and the bottom has dark brown spots, about 1-2 minutes. Flip and cook the other side for another minute.', timerMinutes: 2 },
      { order: 7, instruction: 'Remove from the skillet and immediately brush with garlic butter. Repeat with remaining dough balls.', timerMinutes: null },
      { order: 8, instruction: 'Stack finished naan in a clean kitchen towel to keep warm. Serve alongside curries, dal, or any saucy dish.', timerMinutes: null },
    ],
    notes: 'For even more charring, hold the cooked naan with tongs directly over a gas flame for a few seconds per side. If you prefer plain naan, skip the garlic butter and brush with regular melted butter and a pinch of salt.',

    communityRating: 4.5,
    communityRatingCount: 350,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-15').toISOString(),
  },

  // 7. Raita
  {
    title: 'Raita',
    description:
      'A cooling yogurt condiment studded with crisp cucumber, fragrant cumin, and fresh herbs. This refreshing side is the perfect counterbalance to spicy Indian dishes.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/raita.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/raita-prep.jpg', caption: 'Grating cucumber for the raita', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 0,
    totalTime: 10,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Indian',
    region: 'South Asia',
    country: 'India',

    categories: ['Sides', 'Sauces & Dips'],
    tags: [
      'vegetarian',
      'gluten-free',
      'low-calorie',
      'low-carb',
      'no-cook',
      'under-15-min',
      '5-ingredients-or-less',
      'family-friendly',
    ],

    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 80,
      protein: 5,
      carbs: 8,
      fat: 3,
      fiber: 0,
      sugar: 6,
      sodium: 280,
      iron: 0.5,
    },

    ingredients: [
      { qty: 2, unit: 'cups', item: 'plain yogurt (whole milk or low-fat)', group: 'Main' },
      { qty: 1, unit: 'medium', item: 'cucumber, grated and squeezed dry', group: 'Main' },
      { qty: 0.5, unit: 'tsp', item: 'roasted cumin powder', group: 'Seasoning' },
      { qty: 0.25, unit: 'tsp', item: 'salt', group: 'Seasoning' },
      { qty: 0.125, unit: 'tsp', item: 'black pepper', group: 'Seasoning' },
      { qty: 0.125, unit: 'tsp', item: 'red chili powder (optional)', group: 'Seasoning' },
      { qty: 2, unit: 'tbsp', item: 'fresh mint, finely chopped', group: 'Herbs' },
      { qty: 1, unit: 'tbsp', item: 'fresh cilantro, chopped', group: 'Herbs' },
    ],
    steps: [
      { order: 1, instruction: 'Grate the cucumber on the large holes of a box grater. Squeeze the grated cucumber firmly in a clean kitchen towel or your hands to remove excess water.', timerMinutes: null },
      { order: 2, instruction: 'In a bowl, whisk the yogurt until smooth.', timerMinutes: null },
      { order: 3, instruction: 'Add the squeezed cucumber, roasted cumin powder, salt, black pepper, and chili powder if using. Mix well.', timerMinutes: null },
      { order: 4, instruction: 'Fold in the fresh mint and cilantro. Taste and adjust seasoning.', timerMinutes: null },
      { order: 5, instruction: 'Chill for at least 15 minutes before serving to let the flavors meld. Serve alongside biryani, kebabs, or any spicy curry.', timerMinutes: 15 },
    ],
    notes: 'To make boondi raita, replace the cucumber with 1 cup of store-bought boondi (tiny fried chickpea flour balls) soaked in warm water for 5 minutes and squeezed dry. Raita can be made up to a day ahead and stored in the refrigerator.',

    communityRating: 4.2,
    communityRatingCount: 180,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-15').toISOString(),
  },

  // 8. Dosa with Coconut Chutney
  {
    title: 'Dosa with Coconut Chutney',
    description:
      'Paper-thin, golden-crisp rice and lentil crepes served with a fragrant coconut chutney. This iconic South Indian breakfast is naturally vegan, high in protein, and deeply satisfying.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/dosa.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/dosa-prep.jpg', caption: 'Spreading dosa batter on a hot griddle', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 30,
    cookTime: 30,
    totalTime: 60,
    difficulty: 'hard',
    spiceLevel: 1,

    cuisine: 'Indian',
    region: 'South Asia',
    country: 'India',

    categories: ['Breakfast'],
    tags: [
      'vegan',
      'vegetarian',
      'dairy-free',
      'gluten-free',
      'high-protein',
      'high-iron',
      'high-fiber',
      'budget-friendly',
      'family-friendly',
      'brunch',
    ],

    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 290,
      protein: 10,
      carbs: 48,
      fat: 7,
      fiber: 4,
      sugar: 2,
      sodium: 340,
      iron: 3.2,
    },

    ingredients: [
      { qty: 2, unit: 'cups', item: 'dosa rice (or regular long-grain rice)', group: 'Batter' },
      { qty: 0.75, unit: 'cup', item: 'whole urad dal (black gram, husked)', group: 'Batter' },
      { qty: 0.25, unit: 'cup', item: 'chana dal', group: 'Batter' },
      { qty: 0.5, unit: 'tsp', item: 'fenugreek seeds', group: 'Batter' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Batter' },
      { qty: 2, unit: 'cups', item: 'water, for grinding', group: 'Batter' },
      { qty: 2, unit: 'tbsp', item: 'vegetable oil, for cooking', group: 'Cooking' },
      { qty: 1, unit: 'cup', item: 'fresh or frozen grated coconut', group: 'Coconut Chutney' },
      { qty: 2, unit: 'tbsp', item: 'roasted chana dal', group: 'Coconut Chutney' },
      { qty: 1, unit: '', item: 'green chili', group: 'Coconut Chutney' },
      { qty: 0.5, unit: 'inch', item: 'fresh ginger', group: 'Coconut Chutney' },
      { qty: 0.5, unit: 'cup', item: 'water', group: 'Coconut Chutney' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Coconut Chutney' },
      { qty: 1, unit: 'tsp', item: 'vegetable oil', group: 'Chutney Tempering' },
      { qty: 0.5, unit: 'tsp', item: 'mustard seeds', group: 'Chutney Tempering' },
      { qty: 1, unit: 'sprig', item: 'curry leaves', group: 'Chutney Tempering' },
      { qty: 1, unit: '', item: 'dried red chili', group: 'Chutney Tempering' },
    ],
    steps: [
      { order: 1, instruction: 'Soak the rice in one bowl and the urad dal, chana dal, and fenugreek seeds in another bowl, both covered with plenty of water, for at least 6 hours or overnight.', timerMinutes: 360 },
      { order: 2, instruction: 'Drain and grind the dal mixture first in a blender with just enough water to form a very smooth, fluffy paste. Transfer to a large bowl. Then grind the rice to a slightly gritty paste and combine with the dal batter. Add salt and mix well.', timerMinutes: null },
      { order: 3, instruction: 'Cover the bowl loosely and let the batter ferment in a warm place for 8-12 hours until it has doubled in volume and smells slightly sour.', timerMinutes: 480 },
      { order: 4, instruction: 'Make the coconut chutney: blend coconut, roasted chana dal, green chili, ginger, water, and salt until smooth. Heat oil in a small pan, add mustard seeds, curry leaves, and dried red chili. When the seeds pop, pour over the chutney and stir.', timerMinutes: null },
      { order: 5, instruction: 'Stir the fermented batter gently. It should be the consistency of thin pancake batter; add water a tablespoon at a time if needed.', timerMinutes: null },
      { order: 6, instruction: 'Heat a large non-stick or cast iron skillet (or a dosa tawa) over medium-high heat. Sprinkle a few drops of water on the surface; they should sizzle and evaporate immediately.', timerMinutes: null },
      { order: 7, instruction: 'Pour a ladleful of batter into the center of the pan and quickly spread it in a circular motion from the center outward to form a thin crepe. Drizzle a teaspoon of oil around the edges.', timerMinutes: null },
      { order: 8, instruction: 'Cook until the bottom is golden brown and the edges lift easily, about 2 minutes. Fold the dosa in half or roll it up. Serve immediately with coconut chutney and sambar.', timerMinutes: 2 },
    ],
    notes: 'The batter must ferment properly for the best flavor and crispness. In cold climates, place the bowl in an oven with just the light turned on. Leftover batter keeps in the refrigerator for 3-4 days. Note: total time does not include soaking and fermentation.',

    communityRating: 4.5,
    communityRatingCount: 220,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-15').toISOString(),
  },

  // 9. Saag Paneer
  {
    title: 'Saag Paneer',
    description:
      'Cubes of golden pan-fried paneer nestled in a velvety, richly spiced spinach sauce. This beloved North Indian classic is high in iron, protein, and comfort.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/saag-paneer.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/saag-paneer-prep.jpg', caption: 'Blanching fresh spinach', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 30,
    totalTime: 45,
    difficulty: 'medium',
    spiceLevel: 2,

    cuisine: 'Indian',
    region: 'South Asia',
    country: 'India',

    categories: ['Dinner'],
    tags: [
      'vegetarian',
      'gluten-free',
      'high-protein',
      'high-iron',
      'high-fiber',
      'low-carb',
      'one-pot',
      'comfort-food',
      'weeknight-dinner',
      'family-friendly',
    ],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 360,
      protein: 22,
      carbs: 12,
      fat: 26,
      fiber: 5,
      sugar: 3,
      sodium: 580,
      iron: 6.5,
    },

    ingredients: [
      { qty: 1, unit: 'lb', item: 'fresh spinach (or 10 oz frozen, thawed)', group: 'Greens' },
      { qty: 4, unit: 'oz', item: 'mustard greens (optional, for authentic saag)', group: 'Greens' },
      { qty: 14, unit: 'oz', item: 'paneer, cut into 1-inch cubes', group: 'Main' },
      { qty: 3, unit: 'tbsp', item: 'ghee or butter', group: 'Main' },
      { qty: 1, unit: 'large', item: 'yellow onion, finely diced', group: 'Main' },
      { qty: 4, unit: 'cloves', item: 'garlic, minced', group: 'Main' },
      { qty: 1, unit: 'inch', item: 'fresh ginger, grated', group: 'Main' },
      { qty: 1, unit: '', item: 'green chili, minced', group: 'Main' },
      { qty: 1, unit: 'tsp', item: 'cumin seeds', group: 'Spices' },
      { qty: 1, unit: 'tsp', item: 'ground coriander', group: 'Spices' },
      { qty: 0.5, unit: 'tsp', item: 'ground turmeric', group: 'Spices' },
      { qty: 0.5, unit: 'tsp', item: 'garam masala', group: 'Spices' },
      { qty: 0.5, unit: 'tsp', item: 'red chili powder', group: 'Spices' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Spices' },
      { qty: 0.25, unit: 'cup', item: 'heavy cream', group: 'Finishing' },
      { qty: 1, unit: 'tbsp', item: 'butter', group: 'Finishing' },
    ],
    steps: [
      { order: 1, instruction: 'Bring a large pot of water to a boil. Add spinach (and mustard greens if using) and blanch for 2 minutes. Drain and immediately plunge into ice water to preserve the bright green color. Squeeze dry and blend into a smooth puree.', timerMinutes: 2 },
      { order: 2, instruction: 'Heat 1 tbsp ghee in a non-stick pan over medium-high heat. Fry paneer cubes until golden on all sides, about 3-4 minutes. Remove and set aside.', timerMinutes: 4 },
      { order: 3, instruction: 'In the same pan, add remaining ghee. Add cumin seeds and let them splutter for 15 seconds.', timerMinutes: null },
      { order: 4, instruction: 'Add diced onion and saute until soft and translucent, about 5 minutes.', timerMinutes: 5 },
      { order: 5, instruction: 'Add garlic, ginger, and green chili. Cook for 1 minute. Stir in ground coriander, turmeric, red chili powder, and salt. Cook for 30 seconds.', timerMinutes: null },
      { order: 6, instruction: 'Pour in the spinach puree and stir well. Simmer on low heat for 10 minutes, stirring occasionally.', timerMinutes: 10 },
      { order: 7, instruction: 'Stir in heavy cream and garam masala. Add the fried paneer cubes and gently fold them in. Cook for another 3 minutes to let the paneer absorb the flavors.', timerMinutes: 3 },
      { order: 8, instruction: 'Finish with a pat of butter on top and serve hot with naan or steamed basmati rice.', timerMinutes: null },
    ],
    notes: 'For a vegan version, substitute paneer with extra-firm tofu and use coconut cream instead of heavy cream. Mustard greens add a wonderful peppery bite that distinguishes saag from palak paneer.',

    communityRating: 4.6,
    communityRatingCount: 290,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-15').toISOString(),
  },

  // 10. Kheer
  {
    title: 'Kheer',
    description:
      'A luscious Indian rice pudding slow-simmered in whole milk with fragrant cardamom, saffron, and crunchy toasted nuts. This beloved dessert is served at festivals and celebrations across India.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/kheer.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/kheer-prep.jpg', caption: 'Simmering rice in thickened milk', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 10,
    cookTime: 45,
    totalTime: 55,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Indian',
    region: 'South Asia',
    country: 'India',

    categories: ['Dessert'],
    tags: [
      'vegetarian',
      'gluten-free',
      'nut-free',
      'one-pot',
      'comfort-food',
      'celebration',
      'holiday',
      'family-friendly',
      'make-ahead',
    ],

    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 310,
      protein: 9,
      carbs: 48,
      fat: 10,
      fiber: 1,
      sugar: 32,
      sodium: 120,
      iron: 0.8,
    },

    ingredients: [
      { qty: 0.33, unit: 'cup', item: 'basmati rice, rinsed and soaked 20 minutes', group: 'Main' },
      { qty: 8, unit: 'cups', item: 'whole milk', group: 'Main' },
      { qty: 0.5, unit: 'cup', item: 'sugar', group: 'Main' },
      { qty: 0.25, unit: 'tsp', item: 'saffron threads', group: 'Flavoring' },
      { qty: 0.5, unit: 'tsp', item: 'ground cardamom', group: 'Flavoring' },
      { qty: 1, unit: 'tbsp', item: 'rose water (optional)', group: 'Flavoring' },
      { qty: 2, unit: 'tbsp', item: 'slivered almonds, toasted', group: 'Garnish' },
      { qty: 2, unit: 'tbsp', item: 'shelled pistachios, chopped', group: 'Garnish' },
      { qty: 1, unit: 'tbsp', item: 'golden raisins', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Pour milk into a heavy-bottomed pot and bring to a boil over medium-high heat, stirring frequently to prevent scorching on the bottom.', timerMinutes: null },
      { order: 2, instruction: 'Drain the soaked rice and add it to the boiling milk. Reduce heat to medium-low and simmer, stirring every 3-4 minutes, until the rice is very soft and the milk has reduced by about a third, approximately 35 minutes.', timerMinutes: 35 },
      { order: 3, instruction: 'Crush the saffron threads between your fingers and add them to the pot along with sugar and ground cardamom. Stir until the sugar is fully dissolved.', timerMinutes: null },
      { order: 4, instruction: 'Continue simmering for another 10 minutes, stirring occasionally, until the kheer has a creamy, slightly thick consistency. It will thicken more as it cools.', timerMinutes: 10 },
      { order: 5, instruction: 'Remove from heat and stir in rose water if using. Pour into a serving bowl or individual cups.', timerMinutes: null },
      { order: 6, instruction: 'Garnish with toasted almonds, pistachios, and golden raisins. Serve warm, at room temperature, or chilled.', timerMinutes: null },
    ],
    notes: 'Kheer tastes wonderful both warm and cold. It will thicken considerably in the refrigerator, so thin it with a splash of milk when reheating. Despite the "nut-free" tag, the recipe includes nuts as a garnish that can be omitted for nut allergies.',

    communityRating: 4.4,
    communityRatingCount: 200,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-15').toISOString(),
  },

  // 11. Masala Chai
  {
    title: 'Masala Chai',
    description:
      'An aromatic spiced milk tea brewed with whole cardamom, cinnamon, ginger, and cloves. This soul-warming drink is India\'s most beloved daily ritual, balancing bold tea with creamy sweetness.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/masala-chai.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/masala-chai-prep.jpg', caption: 'Crushing whole spices for chai', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 2,
    prepTime: 5,
    cookTime: 10,
    totalTime: 15,
    difficulty: 'easy',
    spiceLevel: 1,

    cuisine: 'Indian',
    region: 'South Asia',
    country: 'India',

    categories: ['Drinks & Smoothies'],
    tags: [
      'vegetarian',
      'gluten-free',
      'nut-free',
      'egg-free',
      'under-15-min',
      'one-pot',
      'comfort-food',
      'budget-friendly',
      'pantry-staples',
    ],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 120,
      protein: 4,
      carbs: 18,
      fat: 4,
      fiber: 0,
      sugar: 14,
      sodium: 60,
      iron: 1.0,
    },

    ingredients: [
      { qty: 1.5, unit: 'cups', item: 'water', group: 'Main' },
      { qty: 1, unit: 'cup', item: 'whole milk', group: 'Main' },
      { qty: 2, unit: 'tsp', item: 'loose-leaf black tea (Assam or CTC)', group: 'Main' },
      { qty: 2, unit: 'tbsp', item: 'sugar, or to taste', group: 'Main' },
      { qty: 3, unit: '', item: 'green cardamom pods, lightly crushed', group: 'Spices' },
      { qty: 1, unit: '', item: 'cinnamon stick (2-inch)', group: 'Spices' },
      { qty: 3, unit: '', item: 'whole cloves', group: 'Spices' },
      { qty: 3, unit: '', item: 'whole black peppercorns', group: 'Spices' },
      { qty: 1, unit: 'inch', item: 'fresh ginger, sliced or crushed', group: 'Spices' },
    ],
    steps: [
      { order: 1, instruction: 'Add water to a small saucepan along with the crushed cardamom pods, cinnamon stick, cloves, peppercorns, and sliced ginger. Bring to a boil.', timerMinutes: null },
      { order: 2, instruction: 'Once boiling, reduce heat to medium and let the spices simmer for 3 minutes to release their flavor.', timerMinutes: 3 },
      { order: 3, instruction: 'Add the loose-leaf tea and let it brew for 2 minutes on a gentle boil.', timerMinutes: 2 },
      { order: 4, instruction: 'Pour in the milk and sugar. Increase heat and bring the mixture back to a rolling boil, watching carefully as it will rise quickly.', timerMinutes: null },
      { order: 5, instruction: 'Reduce heat and simmer for 3-4 minutes, letting the chai turn a rich caramel color. For stronger chai, let it simmer longer.', timerMinutes: 4 },
      { order: 6, instruction: 'Strain the chai through a fine-mesh strainer into cups. Serve immediately.', timerMinutes: null },
    ],
    notes: 'Assam CTC (crush-tear-curl) tea gives the strongest, most authentic chai flavor. For a richer cup, increase the milk-to-water ratio. You can make a large batch of the dry spice blend and store it in an airtight jar for convenience.',

    communityRating: 4.7,
    communityRatingCount: 390,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-15').toISOString(),
  },

  // 12. Vegetable Korma
  {
    title: 'Vegetable Korma',
    description:
      'A luxuriously creamy and mildly spiced vegetable curry with cashew paste, coconut milk, and an array of colorful vegetables. This Mughlai-inspired dish is gentle enough for spice-sensitive palates while still deeply flavorful.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/vegetable-korma.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/vegetable-korma-prep.jpg', caption: 'Blending cashew cream sauce', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 20,
    cookTime: 35,
    totalTime: 55,
    difficulty: 'medium',
    spiceLevel: 1,

    cuisine: 'Indian',
    region: 'South Asia',
    country: 'India',

    categories: ['Dinner', 'Family Meals'],
    tags: [
      'vegetarian',
      'gluten-free',
      'high-fiber',
      'high-iron',
      'one-pot',
      'comfort-food',
      'weeknight-dinner',
      'family-friendly',
      'date-night',
    ],

    ageGroups: ['kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 380,
      protein: 10,
      carbs: 32,
      fat: 25,
      fiber: 7,
      sugar: 8,
      sodium: 520,
      iron: 3.5,
    },

    ingredients: [
      { qty: 2, unit: 'medium', item: 'potatoes, peeled and cubed', group: 'Vegetables' },
      { qty: 1, unit: 'cup', item: 'cauliflower florets', group: 'Vegetables' },
      { qty: 1, unit: 'cup', item: 'green beans, trimmed and cut into 1-inch pieces', group: 'Vegetables' },
      { qty: 1, unit: 'medium', item: 'carrot, peeled and diced', group: 'Vegetables' },
      { qty: 0.5, unit: 'cup', item: 'frozen green peas', group: 'Vegetables' },
      { qty: 0.25, unit: 'cup', item: 'raw cashews, soaked in warm water for 15 minutes', group: 'Sauce' },
      { qty: 0.5, unit: 'cup', item: 'coconut milk', group: 'Sauce' },
      { qty: 1, unit: 'large', item: 'yellow onion, roughly chopped', group: 'Sauce' },
      { qty: 3, unit: 'cloves', item: 'garlic', group: 'Sauce' },
      { qty: 1, unit: 'inch', item: 'fresh ginger', group: 'Sauce' },
      { qty: 3, unit: 'tbsp', item: 'ghee or vegetable oil', group: 'Main' },
      { qty: 3, unit: '', item: 'green cardamom pods', group: 'Whole Spices' },
      { qty: 3, unit: '', item: 'whole cloves', group: 'Whole Spices' },
      { qty: 1, unit: '', item: 'cinnamon stick (2-inch)', group: 'Whole Spices' },
      { qty: 1, unit: '', item: 'bay leaf', group: 'Whole Spices' },
      { qty: 0.5, unit: 'tsp', item: 'ground turmeric', group: 'Ground Spices' },
      { qty: 1, unit: 'tsp', item: 'ground coriander', group: 'Ground Spices' },
      { qty: 0.5, unit: 'tsp', item: 'garam masala', group: 'Ground Spices' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Ground Spices' },
      { qty: 0.5, unit: 'cup', item: 'water', group: 'Main' },
      { qty: 2, unit: 'tbsp', item: 'fresh cilantro, chopped', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Drain the soaked cashews and blend them with coconut milk, onion, garlic, and ginger into a smooth paste. Set aside.', timerMinutes: null },
      { order: 2, instruction: 'Heat ghee in a large heavy pot over medium heat. Add cardamom, cloves, cinnamon, and bay leaf. Let them sizzle for 30 seconds until fragrant.', timerMinutes: null },
      { order: 3, instruction: 'Pour in the cashew-onion paste. Cook, stirring frequently, for 8-10 minutes until the mixture darkens slightly and the raw smell cooks off.', timerMinutes: 10 },
      { order: 4, instruction: 'Add turmeric, ground coriander, and salt. Stir for 1 minute.', timerMinutes: null },
      { order: 5, instruction: 'Add potatoes, cauliflower, carrots, and green beans along with the water. Stir to combine, cover, and simmer for 20 minutes until vegetables are tender.', timerMinutes: 20 },
      { order: 6, instruction: 'Add frozen peas and garam masala. Cook uncovered for another 5 minutes. Adjust salt and consistency, adding a splash of water if the sauce is too thick.', timerMinutes: 5 },
      { order: 7, instruction: 'Garnish with fresh cilantro and serve with basmati rice, naan, or roti.', timerMinutes: null },
    ],
    notes: 'For a vegan version, use vegetable oil instead of ghee and ensure the coconut milk is full-fat for maximum creaminess. Paneer cubes or boiled eggs can be added for extra protein.',

    communityRating: 4.3,
    communityRatingCount: 230,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-15').toISOString(),
  },

  // ============================================================
  // MEDITERRANEAN RECIPES (13-20)
  // ============================================================

  // 13. Hummus
  {
    title: 'Hummus',
    description:
      'Ultra-smooth and creamy classic chickpea dip whipped with tahini, fresh lemon, and garlic. This Middle Eastern staple is perfect for scooping with warm pita or pairing with a crudite platter.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/hummus.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/hummus-prep.jpg', caption: 'Blending chickpeas with tahini', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 10,
    cookTime: 0,
    totalTime: 10,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Middle Eastern',
    region: 'Mediterranean',
    country: 'Lebanon',

    categories: ['Appetizers', 'Sauces & Dips'],
    tags: [
      'vegan',
      'vegetarian',
      'gluten-free',
      'dairy-free',
      'high-protein',
      'high-iron',
      'high-fiber',
      'no-cook',
      'under-15-min',
      'budget-friendly',
      'pantry-staples',
      'make-ahead',
      'party',
      'picnic',
    ],

    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 180,
      protein: 8,
      carbs: 20,
      fat: 9,
      fiber: 5,
      sugar: 1,
      sodium: 320,
      iron: 2.8,
    },

    ingredients: [
      { qty: 2, unit: 'cans (15 oz)', item: 'chickpeas, drained and rinsed', group: 'Main' },
      { qty: 0.33, unit: 'cup', item: 'tahini, well stirred', group: 'Main' },
      { qty: 3, unit: 'tbsp', item: 'fresh lemon juice', group: 'Main' },
      { qty: 2, unit: 'cloves', item: 'garlic', group: 'Main' },
      { qty: 0.5, unit: 'tsp', item: 'ground cumin', group: 'Main' },
      { qty: 0.75, unit: 'tsp', item: 'salt', group: 'Main' },
      { qty: 3, unit: 'tbsp', item: 'ice water', group: 'Main' },
      { qty: 2, unit: 'tbsp', item: 'extra virgin olive oil', group: 'Garnish' },
      { qty: 0.5, unit: 'tsp', item: 'paprika', group: 'Garnish' },
      { qty: 1, unit: 'tbsp', item: 'fresh parsley, chopped', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Process the garlic in a food processor until finely minced. Add tahini and lemon juice and process for 1 minute until thick and creamy, scraping down sides.', timerMinutes: null },
      { order: 2, instruction: 'Add the drained chickpeas, cumin, and salt. Process for 2 minutes, stopping to scrape down the sides as needed.', timerMinutes: null },
      { order: 3, instruction: 'With the food processor running, slowly drizzle in the ice water. Continue processing for another 1-2 minutes until the hummus is very smooth and light.', timerMinutes: null },
      { order: 4, instruction: 'Taste and adjust lemon juice, salt, or garlic to your preference.', timerMinutes: null },
      { order: 5, instruction: 'Transfer to a serving bowl and create a shallow well in the center with the back of a spoon. Drizzle generously with olive oil, sprinkle with paprika and fresh parsley.', timerMinutes: null },
      { order: 6, instruction: 'Serve with warm pita bread, fresh vegetables, or as part of a mezze platter.', timerMinutes: null },
    ],
    notes: 'For the silkiest hummus, peel the chickpeas before blending. The ice water trick creates a lighter, fluffier texture. Hummus keeps well in the refrigerator for up to 5 days.',

    communityRating: 4.6,
    communityRatingCount: 410,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-15').toISOString(),
  },

  // 14. Baba Ganoush
  {
    title: 'Baba Ganoush',
    description:
      'A silky-smooth, smoky roasted eggplant dip blended with tahini, lemon, and garlic. This Levantine classic has an irresistible charred flavor that makes it a showstopper on any appetizer spread.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/baba-ganoush.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/baba-ganoush-prep.jpg', caption: 'Charring eggplant over an open flame', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 10,
    cookTime: 30,
    totalTime: 40,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Middle Eastern',
    region: 'Mediterranean',
    country: 'Lebanon',

    categories: ['Appetizers', 'Sauces & Dips'],
    tags: [
      'vegan',
      'vegetarian',
      'gluten-free',
      'dairy-free',
      'low-calorie',
      'low-carb',
      'high-fiber',
      'grilling',
      'make-ahead',
      'party',
      'picnic',
      'budget-friendly',
    ],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 120,
      protein: 4,
      carbs: 12,
      fat: 7,
      fiber: 5,
      sugar: 4,
      sodium: 280,
      iron: 1.2,
    },

    ingredients: [
      { qty: 2, unit: 'large', item: 'eggplants (about 1 lb each)', group: 'Main' },
      { qty: 3, unit: 'tbsp', item: 'tahini, well stirred', group: 'Main' },
      { qty: 2, unit: 'tbsp', item: 'fresh lemon juice', group: 'Main' },
      { qty: 2, unit: 'cloves', item: 'garlic, minced', group: 'Main' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Main' },
      { qty: 0.25, unit: 'tsp', item: 'ground cumin', group: 'Main' },
      { qty: 2, unit: 'tbsp', item: 'extra virgin olive oil', group: 'Garnish' },
      { qty: 1, unit: 'tbsp', item: 'fresh parsley, chopped', group: 'Garnish' },
      { qty: 0.5, unit: 'tsp', item: 'smoked paprika', group: 'Garnish' },
      { qty: 1, unit: 'tbsp', item: 'pomegranate seeds (optional)', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Prick the eggplants all over with a fork. If you have a gas stove, place them directly on the burner grate over medium-high flame. Alternatively, place on a baking sheet under the broiler. Char on all sides, turning with tongs, until the skin is completely blackened and the eggplant collapses, about 15-20 minutes.', timerMinutes: 20 },
      { order: 2, instruction: 'Transfer charred eggplants to a colander set over a bowl. Let cool for 10 minutes, then peel off and discard the blackened skin. Let the flesh drain for another 5 minutes to remove excess liquid.', timerMinutes: 15 },
      { order: 3, instruction: 'Place the drained eggplant flesh in a bowl. Add tahini, lemon juice, minced garlic, salt, and cumin.', timerMinutes: null },
      { order: 4, instruction: 'Mash with a fork for a rustic, chunky texture, or pulse in a food processor for a smoother dip. Do not over-process; some texture is ideal.', timerMinutes: null },
      { order: 5, instruction: 'Taste and adjust seasoning. Transfer to a serving plate, spread into a shallow layer, and drizzle with olive oil. Sprinkle with smoked paprika, parsley, and pomegranate seeds if using.', timerMinutes: null },
      { order: 6, instruction: 'Serve with warm pita bread, crackers, or fresh vegetables.', timerMinutes: null },
    ],
    notes: 'The smoky flavor comes entirely from charring the eggplant over an open flame. An oven broiler works but produces a milder result. For maximum smokiness, leave the eggplant on the flame until the skin is truly black. Stores well for 3-4 days refrigerated.',

    communityRating: 4.3,
    communityRatingCount: 190,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-15').toISOString(),
  },

  // 15. Grilled Halloumi Salad
  {
    title: 'Grilled Halloumi Salad',
    description:
      'Squeaky, golden-grilled halloumi cheese served warm over a bed of peppery arugula, juicy cherry tomatoes, and crunchy cucumbers with a bright lemon-herb vinaigrette. A vibrant Mediterranean lunch that is ready in minutes.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/grilled-halloumi-salad.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/grilled-halloumi-salad-prep.jpg', caption: 'Grilling halloumi slices on a hot pan', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 8,
    totalTime: 18,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Cypriot',
    region: 'Mediterranean',
    country: 'Cyprus',

    categories: ['Lunch', 'Salads'],
    tags: [
      'vegetarian',
      'gluten-free',
      'high-protein',
      'low-carb',
      'low-calorie',
      'grilling',
      'under-30-min',
      'date-night',
      'lunchbox',
    ],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 310,
      protein: 18,
      carbs: 10,
      fat: 24,
      fiber: 3,
      sugar: 5,
      sodium: 580,
      iron: 1.8,
    },

    ingredients: [
      { qty: 8, unit: 'oz', item: 'halloumi cheese, sliced into 1/2-inch slabs', group: 'Main' },
      { qty: 5, unit: 'oz', item: 'baby arugula', group: 'Salad' },
      { qty: 1, unit: 'cup', item: 'cherry tomatoes, halved', group: 'Salad' },
      { qty: 1, unit: 'medium', item: 'English cucumber, diced', group: 'Salad' },
      { qty: 0.25, unit: 'cup', item: 'Kalamata olives, pitted and halved', group: 'Salad' },
      { qty: 0.25, unit: '', item: 'red onion, thinly sliced', group: 'Salad' },
      { qty: 2, unit: 'tbsp', item: 'fresh mint leaves, torn', group: 'Salad' },
      { qty: 1, unit: 'tbsp', item: 'olive oil, for grilling', group: 'Cooking' },
      { qty: 3, unit: 'tbsp', item: 'extra virgin olive oil', group: 'Dressing' },
      { qty: 2, unit: 'tbsp', item: 'fresh lemon juice', group: 'Dressing' },
      { qty: 1, unit: 'tsp', item: 'honey', group: 'Dressing' },
      { qty: 1, unit: 'tsp', item: 'dried oregano', group: 'Dressing' },
      { qty: 0.25, unit: 'tsp', item: 'salt', group: 'Dressing' },
      { qty: 0.125, unit: 'tsp', item: 'black pepper', group: 'Dressing' },
    ],
    steps: [
      { order: 1, instruction: 'Whisk together the extra virgin olive oil, lemon juice, honey, dried oregano, salt, and pepper in a small bowl. Set the dressing aside.', timerMinutes: null },
      { order: 2, instruction: 'Pat the halloumi slices dry with paper towels. Brush both sides lightly with olive oil.', timerMinutes: null },
      { order: 3, instruction: 'Heat a grill pan or skillet over medium-high heat until very hot. Grill the halloumi for 2-3 minutes per side until golden-brown grill marks appear and the cheese softens slightly.', timerMinutes: 3 },
      { order: 4, instruction: 'Arrange arugula on a large platter. Scatter cherry tomatoes, cucumber, olives, and red onion over the top.', timerMinutes: null },
      { order: 5, instruction: 'Place the warm grilled halloumi on top of the salad. Drizzle the dressing over everything and scatter with fresh torn mint leaves.', timerMinutes: null },
      { order: 6, instruction: 'Serve immediately while the halloumi is still warm and squeaky.', timerMinutes: null },
    ],
    notes: 'Halloumi is best served immediately after grilling as it becomes rubbery when it cools. You can substitute with a firm feta for a different but equally delicious salad.',

    communityRating: 4.5,
    communityRatingCount: 170,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-15').toISOString(),
  },

  // 16. Mediterranean Stuffed Peppers
  {
    title: 'Mediterranean Stuffed Peppers',
    description:
      'Colorful bell peppers stuffed with a fragrant filling of herbed rice, sun-dried tomatoes, feta, and toasted pine nuts. Baked until tender, these make an impressive and wholesome one-dish meal.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/mediterranean-stuffed-peppers.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/mediterranean-stuffed-peppers-prep.jpg', caption: 'Filling peppers with herbed rice mixture', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 20,
    cookTime: 40,
    totalTime: 60,
    difficulty: 'medium',
    spiceLevel: 0,

    cuisine: 'Greek',
    region: 'Mediterranean',
    country: 'Greece',

    categories: ['Dinner', 'Family Meals'],
    tags: [
      'vegetarian',
      'gluten-free',
      'high-fiber',
      'meal-prep',
      'make-ahead',
      'freezer-friendly',
      'family-friendly',
      'weeknight-dinner',
      'batch-cooking',
    ],

    ageGroups: ['kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 340,
      protein: 12,
      carbs: 42,
      fat: 15,
      fiber: 5,
      sugar: 8,
      sodium: 480,
      iron: 2.5,
    },

    ingredients: [
      { qty: 4, unit: 'large', item: 'bell peppers (mixed colors), tops cut off and seeded', group: 'Main' },
      { qty: 1.5, unit: 'cups', item: 'cooked long-grain rice', group: 'Filling' },
      { qty: 0.5, unit: 'cup', item: 'sun-dried tomatoes, chopped', group: 'Filling' },
      { qty: 0.5, unit: 'cup', item: 'Kalamata olives, chopped', group: 'Filling' },
      { qty: 0.5, unit: 'cup', item: 'crumbled feta cheese', group: 'Filling' },
      { qty: 0.25, unit: 'cup', item: 'pine nuts, toasted', group: 'Filling' },
      { qty: 1, unit: 'small', item: 'zucchini, finely diced', group: 'Filling' },
      { qty: 3, unit: 'cloves', item: 'garlic, minced', group: 'Filling' },
      { qty: 1, unit: 'small', item: 'red onion, finely diced', group: 'Filling' },
      { qty: 2, unit: 'tbsp', item: 'fresh basil, chopped', group: 'Filling' },
      { qty: 2, unit: 'tbsp', item: 'fresh parsley, chopped', group: 'Filling' },
      { qty: 1, unit: 'tsp', item: 'dried oregano', group: 'Filling' },
      { qty: 2, unit: 'tbsp', item: 'extra virgin olive oil', group: 'Filling' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Filling' },
      { qty: 0.25, unit: 'tsp', item: 'black pepper', group: 'Filling' },
      { qty: 0.5, unit: 'cup', item: 'marinara sauce or crushed tomatoes', group: 'Baking' },
      { qty: 0.25, unit: 'cup', item: 'water', group: 'Baking' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat the oven to 375F. Cut the tops off the bell peppers and remove seeds and membranes. Stand them upright in a baking dish.', timerMinutes: null },
      { order: 2, instruction: 'Heat olive oil in a skillet over medium heat. Saute onion and zucchini for 4-5 minutes until softened. Add garlic and cook for 1 more minute.', timerMinutes: 5 },
      { order: 3, instruction: 'In a large bowl, combine the cooked rice, sauteed vegetables, sun-dried tomatoes, olives, pine nuts, half the feta, basil, parsley, oregano, salt, and pepper. Toss until well mixed.', timerMinutes: null },
      { order: 4, instruction: 'Spoon the filling generously into each pepper, pressing down gently to pack it in. Top with remaining crumbled feta.', timerMinutes: null },
      { order: 5, instruction: 'Pour marinara sauce and water into the bottom of the baking dish around the peppers.', timerMinutes: null },
      { order: 6, instruction: 'Cover the dish tightly with aluminum foil and bake for 30 minutes.', timerMinutes: 30 },
      { order: 7, instruction: 'Remove the foil and bake for another 10 minutes until the peppers are tender and the tops are lightly browned.', timerMinutes: 10 },
      { order: 8, instruction: 'Let rest for 5 minutes before serving. Spoon the sauce from the bottom of the dish over the peppers.', timerMinutes: 5 },
    ],
    notes: 'These can be assembled a day ahead and refrigerated before baking. For a vegan version, omit the feta and add extra pine nuts or nutritional yeast. Cooked quinoa or bulgur can replace the rice.',

    communityRating: 4.4,
    communityRatingCount: 210,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-15').toISOString(),
  },

  // 17. Lamb Gyros
  {
    title: 'Lamb Gyros',
    description:
      'Warmly spiced, juicy seasoned lamb slices piled into soft pita bread with crisp lettuce, ripe tomatoes, red onion, and a drizzle of cool tzatziki. A Greek street food favorite you can easily make at home.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/lamb-gyros.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/lamb-gyros-prep.jpg', caption: 'Slicing seasoned lamb from the loaf', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 20,
    cookTime: 45,
    totalTime: 65,
    difficulty: 'medium',
    spiceLevel: 1,

    cuisine: 'Greek',
    region: 'Mediterranean',
    country: 'Greece',

    categories: ['Dinner', 'Lunch'],
    tags: [
      'high-protein',
      'high-iron',
      'family-friendly',
      'party',
      'game-day',
      'comfort-food',
      'meal-prep',
      'make-ahead',
    ],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 480,
      protein: 30,
      carbs: 34,
      fat: 24,
      fiber: 3,
      sugar: 4,
      sodium: 680,
      iron: 3.8,
    },

    ingredients: [
      { qty: 1, unit: 'lb', item: 'ground lamb', group: 'Lamb' },
      { qty: 0.5, unit: 'lb', item: 'ground beef (80/20)', group: 'Lamb' },
      { qty: 1, unit: 'small', item: 'yellow onion, grated and squeezed dry', group: 'Lamb' },
      { qty: 4, unit: 'cloves', item: 'garlic, minced', group: 'Lamb' },
      { qty: 2, unit: 'tsp', item: 'dried oregano', group: 'Lamb' },
      { qty: 1, unit: 'tsp', item: 'ground cumin', group: 'Lamb' },
      { qty: 1, unit: 'tsp', item: 'smoked paprika', group: 'Lamb' },
      { qty: 0.5, unit: 'tsp', item: 'ground coriander', group: 'Lamb' },
      { qty: 0.25, unit: 'tsp', item: 'ground cinnamon', group: 'Lamb' },
      { qty: 1.5, unit: 'tsp', item: 'salt', group: 'Lamb' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Lamb' },
      { qty: 6, unit: '', item: 'pita breads, warmed', group: 'Assembly' },
      { qty: 1, unit: 'cup', item: 'shredded lettuce', group: 'Assembly' },
      { qty: 2, unit: 'medium', item: 'tomatoes, sliced', group: 'Assembly' },
      { qty: 0.5, unit: '', item: 'red onion, thinly sliced', group: 'Assembly' },
      { qty: 0.75, unit: 'cup', item: 'tzatziki sauce', group: 'Assembly' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat oven to 350F. In a large bowl, combine ground lamb, ground beef, grated onion, garlic, oregano, cumin, paprika, coriander, cinnamon, salt, and pepper. Mix and knead vigorously for 2-3 minutes until the mixture is very smooth and paste-like.', timerMinutes: null },
      { order: 2, instruction: 'Pack the meat mixture tightly into a loaf pan, pressing out all air pockets. The tighter you pack it, the better the texture.', timerMinutes: null },
      { order: 3, instruction: 'Bake the meat loaf for 45 minutes until the internal temperature reaches 165F. A lot of rendered fat will collect; this is normal.', timerMinutes: 45 },
      { order: 4, instruction: 'Remove from oven and carefully drain the fat. Let the loaf rest in the pan for 10 minutes, then remove and place on a cutting board.', timerMinutes: 10 },
      { order: 5, instruction: 'Slice the lamb loaf as thinly as possible. For extra crispiness, sear the slices in a hot skillet for 30-60 seconds per side.', timerMinutes: null },
      { order: 6, instruction: 'Warm the pita breads in the oven or on a skillet for 30 seconds.', timerMinutes: null },
      { order: 7, instruction: 'Assemble the gyros: layer lettuce, tomato slices, and red onion in each pita. Top with generous slices of lamb and a drizzle of tzatziki. Fold and serve immediately.', timerMinutes: null },
    ],
    notes: 'The key to gyro-style texture is kneading the meat until it becomes a smooth paste, which creates that dense, sliceable consistency. The meat loaf can be made ahead and refrigerated for up to 3 days; slice and crisp in a skillet when ready to serve.',

    communityRating: 4.7,
    communityRatingCount: 340,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-15').toISOString(),
  },

  // 18. Lemon Herb Grilled Fish
  {
    title: 'Lemon Herb Grilled Fish',
    description:
      'Delicate white fish fillets marinated in a bright blend of lemon, garlic, and fresh Mediterranean herbs, then grilled to flaky perfection. A light, healthy, and elegant dish that comes together in under 30 minutes.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/lemon-herb-grilled-fish.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/lemon-herb-grilled-fish-prep.jpg', caption: 'Fish fillets marinating in lemon herb mixture', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 10,
    totalTime: 20,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Greek',
    region: 'Mediterranean',
    country: 'Greece',

    categories: ['Dinner'],
    tags: [
      'pescatarian',
      'gluten-free',
      'dairy-free',
      'low-carb',
      'low-calorie',
      'high-protein',
      'keto',
      'paleo',
      'whole30',
      'grilling',
      'under-30-min',
      'weeknight-dinner',
      'date-night',
    ],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 240,
      protein: 36,
      carbs: 3,
      fat: 10,
      fiber: 0,
      sugar: 1,
      sodium: 420,
      iron: 1.5,
    },

    ingredients: [
      { qty: 4, unit: '', item: 'white fish fillets (branzino, sea bass, or snapper), about 6 oz each', group: 'Main' },
      { qty: 3, unit: 'tbsp', item: 'extra virgin olive oil', group: 'Marinade' },
      { qty: 3, unit: 'tbsp', item: 'fresh lemon juice', group: 'Marinade' },
      { qty: 1, unit: 'tsp', item: 'lemon zest', group: 'Marinade' },
      { qty: 3, unit: 'cloves', item: 'garlic, minced', group: 'Marinade' },
      { qty: 2, unit: 'tbsp', item: 'fresh oregano, chopped (or 2 tsp dried)', group: 'Marinade' },
      { qty: 1, unit: 'tbsp', item: 'fresh thyme leaves', group: 'Marinade' },
      { qty: 1, unit: 'tbsp', item: 'fresh parsley, chopped', group: 'Marinade' },
      { qty: 0.75, unit: 'tsp', item: 'salt', group: 'Marinade' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Marinade' },
      { qty: 1, unit: '', item: 'lemon, sliced into rounds', group: 'Grilling' },
      { qty: 2, unit: 'tbsp', item: 'fresh dill, for garnish', group: 'Garnish' },
      { qty: 1, unit: 'tbsp', item: 'capers (optional)', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'In a shallow dish, whisk together olive oil, lemon juice, lemon zest, garlic, oregano, thyme, parsley, salt, and pepper.', timerMinutes: null },
      { order: 2, instruction: 'Place the fish fillets in the marinade, turning to coat both sides. Let marinate for 15 minutes at room temperature. Do not over-marinate as the acid will begin to "cook" the fish.', timerMinutes: 15 },
      { order: 3, instruction: 'Preheat your grill or grill pan to medium-high heat. Oil the grates well to prevent sticking.', timerMinutes: null },
      { order: 4, instruction: 'Place lemon slices on the grill first, then lay fish fillets on top of the lemon slices (this prevents sticking and adds flavor). Grill for 4-5 minutes per side, depending on thickness, until the fish flakes easily with a fork.', timerMinutes: 5 },
      { order: 5, instruction: 'Carefully flip the fish and grill for another 4-5 minutes until cooked through and opaque in the center.', timerMinutes: 5 },
      { order: 6, instruction: 'Transfer to a serving platter with the grilled lemon slices. Garnish with fresh dill and capers if using. Serve with a green salad and crusty bread.', timerMinutes: null },
    ],
    notes: 'If using thin fillets, reduce cooking time to 2-3 minutes per side. A fish grilling basket makes flipping much easier and prevents the fish from breaking apart. This also works beautifully in a 425F oven on a sheet pan if grilling is not an option.',

    communityRating: 4.5,
    communityRatingCount: 160,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-15').toISOString(),
  },

  // 19. Caprese Salad
  {
    title: 'Caprese Salad',
    description:
      'Ripe summer tomatoes layered with creamy fresh mozzarella, fragrant basil leaves, and a drizzle of premium extra virgin olive oil and balsamic glaze. Simplicity at its most elegant.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/caprese-salad.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/caprese-salad-prep.jpg', caption: 'Slicing fresh mozzarella and tomatoes', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 0,
    totalTime: 10,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Italian',
    region: 'Mediterranean',
    country: 'Italy',

    categories: ['Salads', 'Appetizers'],
    tags: [
      'vegetarian',
      'gluten-free',
      'low-carb',
      'low-calorie',
      'no-cook',
      'under-15-min',
      '5-ingredients-or-less',
      'date-night',
      'party',
      'picnic',
    ],

    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 250,
      protein: 14,
      carbs: 6,
      fat: 19,
      fiber: 1,
      sugar: 4,
      sodium: 380,
      iron: 1.0,
    },

    ingredients: [
      { qty: 3, unit: 'large', item: 'ripe heirloom or vine-ripe tomatoes, sliced 1/4-inch thick', group: 'Main' },
      { qty: 8, unit: 'oz', item: 'fresh mozzarella (burrata for extra indulgence), sliced', group: 'Main' },
      { qty: 1, unit: 'bunch', item: 'fresh basil leaves', group: 'Main' },
      { qty: 3, unit: 'tbsp', item: 'extra virgin olive oil (best quality)', group: 'Dressing' },
      { qty: 2, unit: 'tbsp', item: 'balsamic glaze', group: 'Dressing' },
      { qty: 0.5, unit: 'tsp', item: 'flaky sea salt (such as Maldon)', group: 'Dressing' },
      { qty: 0.25, unit: 'tsp', item: 'freshly cracked black pepper', group: 'Dressing' },
    ],
    steps: [
      { order: 1, instruction: 'Arrange alternating slices of tomato and mozzarella in a slightly overlapping pattern on a large serving plate.', timerMinutes: null },
      { order: 2, instruction: 'Tuck fresh basil leaves between and around the tomato and mozzarella slices.', timerMinutes: null },
      { order: 3, instruction: 'Drizzle generously with your best extra virgin olive oil, then zigzag balsamic glaze over the top.', timerMinutes: null },
      { order: 4, instruction: 'Sprinkle with flaky sea salt and freshly cracked black pepper.', timerMinutes: null },
      { order: 5, instruction: 'Serve immediately at room temperature for the best flavor. Do not refrigerate after assembly.', timerMinutes: null },
    ],
    notes: 'This dish is only as good as its ingredients. Use the ripest, most flavorful tomatoes you can find (farmers market tomatoes in summer are ideal), the freshest mozzarella, and a high-quality olive oil. Burrata makes an especially decadent substitute for regular mozzarella.',

    communityRating: 4.3,
    communityRatingCount: 280,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-15').toISOString(),
  },

  // 20. Tzatziki
  {
    title: 'Tzatziki',
    description:
      'A cool, creamy Greek yogurt dip loaded with grated cucumber, fresh garlic, lemon, and fragrant dill. This versatile sauce is equally at home as a dip, a gyro condiment, or a salad dressing.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/tzatziki.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/tzatziki-prep.jpg', caption: 'Straining grated cucumber', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 15,
    cookTime: 0,
    totalTime: 15,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Greek',
    region: 'Mediterranean',
    country: 'Greece',

    categories: ['Appetizers', 'Sauces & Dips'],
    tags: [
      'vegetarian',
      'gluten-free',
      'low-calorie',
      'low-carb',
      'no-cook',
      'under-15-min',
      '5-ingredients-or-less',
      'make-ahead',
      'party',
      'picnic',
      'budget-friendly',
    ],

    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 70,
      protein: 5,
      carbs: 5,
      fat: 4,
      fiber: 0,
      sugar: 3,
      sodium: 200,
      iron: 0.3,
    },

    ingredients: [
      { qty: 2, unit: 'cups', item: 'Greek yogurt (full-fat for best results)', group: 'Main' },
      { qty: 1, unit: 'medium', item: 'English cucumber, grated', group: 'Main' },
      { qty: 2, unit: 'cloves', item: 'garlic, finely minced or pressed', group: 'Main' },
      { qty: 1, unit: 'tbsp', item: 'extra virgin olive oil', group: 'Main' },
      { qty: 1, unit: 'tbsp', item: 'fresh lemon juice', group: 'Main' },
      { qty: 1, unit: 'tbsp', item: 'red wine vinegar', group: 'Main' },
      { qty: 2, unit: 'tbsp', item: 'fresh dill, finely chopped', group: 'Main' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Main' },
      { qty: 0.25, unit: 'tsp', item: 'white pepper', group: 'Main' },
      { qty: 1, unit: 'tbsp', item: 'extra virgin olive oil, for drizzle', group: 'Garnish' },
      { qty: 1, unit: 'sprig', item: 'fresh dill, for garnish', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Grate the cucumber on the large holes of a box grater. Place the grated cucumber in a clean kitchen towel or several layers of cheesecloth and squeeze firmly to remove as much liquid as possible. This step is critical for a thick, not-watery tzatziki.', timerMinutes: null },
      { order: 2, instruction: 'In a medium bowl, combine the Greek yogurt, squeezed cucumber, minced garlic, olive oil, lemon juice, and red wine vinegar. Stir until well combined.', timerMinutes: null },
      { order: 3, instruction: 'Fold in the fresh dill, salt, and white pepper. Taste and adjust seasoning, adding more garlic, lemon, or salt as desired.', timerMinutes: null },
      { order: 4, instruction: 'Transfer to a serving bowl, drizzle with olive oil, and top with a sprig of fresh dill.', timerMinutes: null },
      { order: 5, instruction: 'For best flavor, cover and refrigerate for at least 1 hour before serving to let the flavors meld.', timerMinutes: 60 },
      { order: 6, instruction: 'Serve with warm pita, as a sauce for gyros, or alongside grilled meats and vegetables.', timerMinutes: null },
    ],
    notes: 'Squeezing the cucumber thoroughly is the single most important step. Use full-fat Greek yogurt for the creamiest result. Tzatziki keeps in the refrigerator for 3-4 days but the garlic flavor will intensify over time. If you prefer a milder dip, start with one clove of garlic.',

    communityRating: 4.4,
    communityRatingCount: 250,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-15').toISOString(),
  },
];

export default indianMediterraneanRecipes;
